import { createContext } from 'react';
export const MicrosoftOAuthContext = createContext();
